import { SearchBarExpansiveModel } from '@components/index';
import {
  Callbacks,
  CriticalDataProduct,
} from '@components/SearchBars/SearchBarExpansiveModel/SearchBarExpansiveModel';
import { getProductModels } from '@services/queries/products';
import { ProductCriticalData } from '@services/queries/products/getProductModels/getProductModels';
import { addKnownProduct } from '@store/redux/features/inventory/knownData';
import { RootState, useAppDispatch } from '@store/redux/store';
import { useRef, memo } from 'react';
import { useController } from 'react-hook-form';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import { BigInputDiv, GlobalHeader, InputList } from '../styles';
import { PropsInputGlobal } from './types';
import { UniqueInput } from './UniqueInput';
import {
  criticalToKnown,
  getSelectedValue,
  mapProductModels,
  onChangeGlobal,
  setForAllNew,
} from './utils';

type IdentificationInputGroupProps = PropsInputGlobal<'productId'>;

// Why render prop works: https://medium.com/@jacobdfriedmann/render-props-composability-and-performance-74dd4ac881e2
/**
 * # Note
 * This does not expect config to change throughout its lifecycle.
 */
export function IdentificationInputGroup(props: IdentificationInputGroupProps) {
  const { viewForm, setFormV, productId, globalViewForm, setGlobalFormV } =
    props;
  // Config Will never change
  const knownProducts = useSelector(
    (state: RootState) => state.knownData.knownProducts,
  );
  const dispatch = useAppDispatch();

  const callbacksRef = useRef<Callbacks | null>(null);

  const { control: viewControl } = globalViewForm;
  const productIdName = 'productId' as const;
  const {
    field: { onChange, value },
  } = useController({
    control: viewControl,
    name: 'view.identificationSearchText',
  });
  const selectedValue: string | null = getSelectedValue(
    productId,
    knownProducts,
  );

  const {
    data,
    remove: removeQuery,
    refetch,
  } = useQuery(
    ['Product', 'Models', 'global'],
    () => getProductModels(value as string),
    {
      enabled: callbacksRef.current !== null,
      onSettled() {
        if (callbacksRef.current) {
          callbacksRef.current.onSuccess(callbacksRef.current.key);
          callbacksRef.current = null;
        }
      },
    },
  );
  const mutationData: ProductCriticalData[] = value === null ? [] : data ?? [];
  const mutationDataMapped: CriticalDataProduct[] =
    mutationData.map(mapProductModels);

  return (
    <InputList>
      <BigInputDiv>
        <GlobalHeader>Model #</GlobalHeader>

        <SearchBarExpansiveModel
          showOptions={mutationDataMapped}
          clearResults={() => removeQuery()}
          searchText={value}
          selectedValue={selectedValue}
          placeholder="Find a Model #"
          onChange={_value => {
            return onChange(_value);
          }}
          onSearch={(cbs: Callbacks) => {
            callbacksRef.current = cbs;
            removeQuery();
            refetch();
          }}
          onCloseIconClick={() => {
            onChange(null);

            if (selectedValue) {
              onChangeGlobal(productIdName, null, setGlobalFormV);

              // If config.global.

              setForAllNew(`productId`, null, setFormV);
            }
          }}
          onSelect={input => {
            dispatch(addKnownProduct(criticalToKnown(input)));
            onChangeGlobal(productIdName, input.id, setGlobalFormV);

            // if config.global.
            setForAllNew(`productId`, input.id, setFormV);
            // Pray this isn't intense
            clearForAll();
          }}
        />
      </BigInputDiv>

      <BigInputDiv>
        <GlobalHeader>Serial #</GlobalHeader>
        <UniqueInput />
      </BigInputDiv>
    </InputList>
  );

  function clearForAll() {
    const { views } = viewForm.getValues();

    views.forEach((_, index) => {
      viewForm.setValue(`views.${index}.identificationSearchText`, null);
    });
  }
}
export default memo(IdentificationInputGroup);
